import React from 'react'
import GlassContainer from './ui/GlassContainer'
import Button from './ui/Button'
import { AlertTriangle, RefreshCw } from 'lucide-react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-primary-900 noise-bg flex items-center justify-center p-4">
          <GlassContainer variant="prominent" className="p-8 max-w-md mx-auto text-center">
            <AlertTriangle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="heading-lg mb-4">Something went wrong</h2>
            <p className="body-sm text-text-secondary mb-6">
              We apologize for the inconvenience. Please try refreshing the page or contact support if the problem persists.
            </p>
            <div className="space-y-3">
              <Button 
                variant="primary" 
                className="w-full"
                onClick={() => window.location.reload()}
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Reload Page
              </Button>
              <Button 
                variant="default" 
                className="w-full"
                onClick={() => window.location.href = '/'}
              >
                Go Home
              </Button>
            </div>
          </GlassContainer>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
